import Recorder from '../libs/recorder-js/index';

export default function() {
  const recorderOptions = {
    numChannels: 1
  };

  return new Promise((resolve, reject) => {
    if (navigator.mediaDevices === undefined) {
      reject(makeError('Media Devices initialization error'));
      return;
    }

    if (window.AudioContext === undefined) {
      reject(makeError('Audio Context initialization error'));
      return;
    }

    const audioContext =  new window.AudioContext();
    const recorder = new Recorder(audioContext, recorderOptions);
    let stream;

    navigator.mediaDevices.getUserMedia({audio: true})
      .then(mediaStream => {
        stream = mediaStream;
        recorder.init(mediaStream);
        resolve({start, stop, destroy});
      })
      .catch(err => {
        reject(makeError('Unable to get input stream', 'RecorderErrorNoDevice'));
      });

    /**
     * @return {Promise<MediaStream>}
     */
    function start() {
      return recorder.start();
    }

    /**
     * @param {string|null} filename
     * @return {Promise<File>}
     */
    function stop(filename = null) {
      return recorder.stop()
        .then(({blob}) => {
          return new File([blob], filename || getFileName(), {type: blob.type});
        })
    }

    /**
     * @return {undefined}
     */
    function destroy() {
      stop().then(() => {
        _.forEach(stream ? stream.getTracks() : [], track => track.stop());
      });
    }

    /**
     * @return {string}
     */
    function getFileName() {
      return `record_${moment.utc().format('YYYY-MM-DD_HH-mm-ss')}.wav`;
    }

    /**
     * @param {string} message
     * @param {string} name
     * @return {Error}
     */
    function makeError(message= 'General error', name = 'RecorderError') {
      return _.tap(new Error(message), val => val.name = name);
    }
  });
}